import { render, staticRenderFns } from "./Plate.vue?vue&type=template&id=22a76abe&lang=pug&"
import script from "./Plate.vue?vue&type=script&lang=ts&"
export * from "./Plate.vue?vue&type=script&lang=ts&"
import style0 from "./Plate.vue?vue&type=style&index=0&id=22a76abe&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports